import styled from 'styled-components'

const Container = styled.p`
    padding: 10px;
`

export {
    Container
}